import { render, staticRenderFns } from "./ExpenditureOptions.vue?vue&type=template&id=4801f0d9&"
import script from "./ExpenditureOptions.js?vue&type=script&lang=js&"
export * from "./ExpenditureOptions.js?vue&type=script&lang=js&"
import style0 from "./ExpenditureOptions.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
